import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliateCouponDelete = {
    path: "/affiliate/coupon",
    method: ERouteHttpVerb.DELETE
};
export { routeLocationAffiliateCouponDelete };
